export default __webpack_public_path__ + "static/Asset8@2x-798907eae7ee0573a76b5389823e31c6.png";